import React from 'react';

const Card = ({
  children,
  className = '',
  padding = 'default',
  ...props
}) => {
  const paddingClasses = {
    none: '',
    sm: 'p-4',
    default: 'p-6',
    lg: 'p-8',
  };

  return (
    <div
      className={`
        rounded-sm border border-stroke bg-white shadow-default
        dark:border-strokedark dark:bg-boxdark
        ${paddingClasses[padding]}
        ${className}
      `}
      {...props}
    >
      {children}
    </div>
  );
};

const CardHeader = ({ children, className = '' }) => (
  <div className={`border-b border-stroke px-6 py-4 dark:border-strokedark ${className}`}>
    {children}
  </div>
);

const CardTitle = ({ children, className = '' }) => (
  <h4 className={`text-xl font-semibold text-black dark:text-white ${className}`}>
    {children}
  </h4>
);

const CardContent = ({ children, className = '' }) => (
  <div className={`p-6 ${className}`}>
    {children}
  </div>
);

const CardFooter = ({ children, className = '' }) => (
  <div className={`border-t border-stroke px-6 py-4 dark:border-strokedark ${className}`}>
    {children}
  </div>
);

Card.Header = CardHeader;
Card.Title = CardTitle;
Card.Content = CardContent;
Card.Footer = CardFooter;

export default Card;
